import { useInfiniteQuery } from "@tanstack/react-query";
import type { QueryFunctionContext } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptComments } from "../../adapters/adaptComments";

const fetchPostComments = async (postId: string, nextPageUrl?: string) => {
	const url = nextPageUrl ?? "/comments/";
	const { data } = await cmsClient.get<CMSPaginatedData<IComment>>(url, {
		params: nextPageUrl ? undefined : { post_id: postId }
	});
	return data;
};

const usePostComments = (postId: string, enabled = false) => {
	const queryKey = ["post-comments", postId];

	const queryFn = (context: QueryFunctionContext) => {
		return fetchPostComments(postId, context.pageParam);
	};

	const getNextPageParam = (lastPage: CMSPaginatedData<IComment>) => {
		return lastPage.next;
	};

	return useInfiniteQuery({
		queryKey,
		queryFn,
		getNextPageParam,
		enabled: enabled && Boolean(postId),
		select: (data) => ({
			...data,
			pages: data.pages.map((page) => ({
				...page,
				results: adaptComments(page.results)
			}))
		})
	});
};

export default usePostComments;
